import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', path: '/' },
  { label: '电视剧', path: '/category/dianshiju' },
  { label: '电影', path: '/category/dianying' },
  { label: '综艺', path: '/category/zongyi' },
  { label: '动漫', path: '/category/dongman' },
  { label: '资讯', path: '/category/zixun' },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-play-fill text-xl text-white"></i>
            </div>
            <span className={`font-heading text-xl ${isScrolled ? 'text-foreground-900' : 'text-white'}`}>
              黄瓜视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path || 
                (link.path !== '/' && location.pathname.startsWith(link.path));
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    isActive
                      ? isScrolled
                        ? 'bg-primary-100 text-primary-700'
                        : 'bg-white/20 text-white'
                      : isScrolled
                        ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-200'
                        : 'text-white/80 hover:text-white hover:bg-white/10'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'bg-background-200 text-foreground-700 hover:bg-background-300'
                  : 'bg-white/15 text-white hover:bg-white/25'
              }`}
            >
              <i className="ri-search-line"></i>
              <span>搜索</span>
            </button>
            <button className="px-5 py-2 rounded-full text-sm font-medium bg-primary-500 text-white hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer">
              登录/注册
            </button>
          </div>

          <button
            className="md:hidden flex items-center justify-center w-10 h-10 rounded-lg cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i
              className={`text-xl ${isScrolled ? 'text-foreground-900' : 'text-white'} ${
                isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'
              }`}
            ></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path;
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    isActive
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <div className="flex items-center gap-2 mt-2 pt-2 border-t border-background-200">
              <button className="flex-1 px-4 py-2.5 rounded-full text-sm font-medium bg-background-200 text-foreground-700 whitespace-nowrap cursor-pointer">
                <i className="ri-search-line mr-1"></i>搜索
              </button>
              <button className="flex-1 px-4 py-2.5 rounded-full text-sm font-medium bg-primary-500 text-white whitespace-nowrap cursor-pointer">
                登录/注册
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}